// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3mktW","signatureBlock":"Footer_signatureBlock__G3g24","signature":"Footer_signature__2HFYa"};